module.exports = __webpack_public_path__ + "static/img/logo_s@4x.2c122b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_s@4x.png
// module id = ul7R
// module chunks = 2